import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Grid } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { PrivacyPolicyScreen } from "./static/PrivacyPolicyScreen";
import { SupportScreen } from "./static/SupportScreen";

export const useStyles = makeStyles(
  (theme) => ({
    footer: {
      backgroundColor: theme.palette.secondary.main,
      height: "2%",
      width: "100%",
    },
    ul: {
      float: "right",
      listStyleType: "none",
      padding: 0,
      margin: 0,
      overflow: "hidden",

      "& li": {
        display: "inline-flex",
        alignItems: "right",
        justifyContent: "right",

        float: "left",
        fontSize: 10,
        marginBottom: 2,
        color: "white",
        marginRight: theme.spacing(2),
        fontWeight: theme.typography.fontWeightMedium,
        cursor: "pointer",

        "& a": {
          color: "white",
          textDecoration: "underline",
        },

        "&:hover": {
          textDecoration: "underline",
        },

        "&.current": {
          fontSize: 12,
          color: "green",
          fontWeight: theme.typography.fontWeightBold,
        },
      },
    },
  }),
  {
    name: "language-chooser-style",
    flip: null,
  }
);

export const Footer = (props: any) => {
  const classes = useStyles(props);

  return (
    <Grid container className={classes.footer}>
      <Grid xs={10} sm={1}></Grid>
      <Grid xs={3} sm={12}>
        <Box component="ul" className={classes.ul}>
          <Box component="li">
            <Link to={`${PrivacyPolicyScreen.routeName}`}>
              <FormattedMessage id="sharedScreen.privacyPolicy" />
            </Link>
          </Box>
          <Box component="li">
            <Link to={`${SupportScreen.routeName}`}>
              <FormattedMessage id="sharedScreen.support" />
            </Link>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
